import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./FoldersUIHelpers";

const FoldersUIContext = createContext();

export function useFoldersUIContext() {
  return useContext(FoldersUIContext);
}

export const FoldersUIConsumer = FoldersUIContext.Consumer;

export function FoldersUIProvider({ foldersUIEvents, children }) {
  // const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const [favoriteIds, setFavoriteIds] = useState([]);
  // const setQueryParams = useCallback(nextQueryParams => {
  //     setQueryParamsBase(prevQueryParams => {
  //         if (isFunction(nextQueryParams)) {
  //             nextQueryParams = nextQueryParams(prevQueryParams);
  //         }

  //         if (isEqual(prevQueryParams, nextQueryParams)) {
  //             return prevQueryParams;
  //         }

  //         return nextQueryParams;
  //     });
  // }, []);

  const value = {
    // queryParams,
    // setQueryParamsBase,
    ids,
    setIds,
    favoriteIds,
    setFavoriteIds,
    // setQueryParams,
  };

  return (
    <FoldersUIContext.Provider value={value}>
      {children}
    </FoldersUIContext.Provider>
  );
}
